export default __webpack_public_path__ + "static/media/romeo.e0d1c734.jpg";